import { useStore } from 'zustand';
import { createStore } from 'zustand/vanilla';

interface RefreshPageState {
    shouldRefresh: boolean;
    setRefreshPage: () => void;
    reset: () => void;
}

// To be able to be used anywhere (e.g. in dispatch)
const refreshPageStore = createStore<RefreshPageState>((set) => ({
    shouldRefresh: false,
    setRefreshPage: () => set(() => ({ shouldRefresh: true })),
    reset: () => set(() => ({ shouldRefresh: false })),
}));

export const useRefreshPageStore = () => useStore(refreshPageStore);
export const setRefreshPage = () => refreshPageStore.getState().setRefreshPage();
